export default __webpack_public_path__ + "static/taskdefinition_01-66774c0048b7647cf13ddb17eaa0aac8.png";